"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Label = _interopRequireDefault(require("../Label"));
var _Below = _interopRequireDefault(require("./Below"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["tooltip", "tooltipAlign", "mobileTooltipAlign", "setValue", "label", "labelClass", "helperText", "required", "noErrorsOrHelper", "errorText", "description", "error", "setError", "disabled"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".OTPInput {\n  display: flex;\n  flex-direction: column;\n}\n.OTPInput--disabled {\n  opacity: 0.5;\n  pointer-events: none;\n}\n.OTPInput__fieldContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.OTPInput__singleField {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin: 0 0.5rem;\n  height: 3rem;\n  width: 3rem;\n  border: 1px solid #bebebe;\n  border-radius: 0.188rem;\n  font-size: 1rem;\n  line-height: 1.5rem;\n  color: #424242;\n  appearance: none;\n  box-sizing: border-box;\n  outline: 0;\n  position: relative;\n  cursor: text;\n  flex: 1;\n}\n.OTPInput__singleField:focus {\n  border-color: #0a5ec0;\n  color: #424242;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15), 0px 2px 15px rgba(0, 0, 0, 0.0750929);\n}\n.OTPInput__singleField:focus::before {\n  display: block;\n  content: \"\";\n  width: 1px;\n  height: 1.5rem;\n  background-color: #424242;\n}\n.OTPInput__singleField:first-of-type {\n  margin-left: 0;\n}\n.OTPInput__singleField:first-of-type:focus::before {\n  display: none;\n}\n.OTPInput__singleField:first-of-type:focus::after {\n  display: block;\n  content: \"\";\n  width: 1px;\n  height: 1.5rem;\n  background-color: #424242;\n}\n.OTPInput__singleField:hover:not(:focus) {\n  border: 1px solid #767676;\n}\n.OTPInput__singleField--error {\n  border: 1px solid #c60f13;\n}\n.OTPInput__singleField--error:focus {\n  border-color: #c60f13;\n  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15), 0px 2px 15px rgba(0, 0, 0, 0.0750929);\n}\n@media (max-width: 375px) {\n  .OTPInput__singleField {\n    margin: 0 0.25rem;\n  }\n}\n.OTPInput__description {\n  font-size: 0.75rem;\n  line-height: 1rem;\n  min-height: 1.25rem;\n  margin: 2px 0.25rem 0 0.25rem;\n  color: #767676;\n  font-weight: normal;\n}\n.OTPInput__description--error {\n  font-weight: bold;\n  color: #c60f13;\n}";
  var fileName = "InputOTP_InputOTP";
  var element = document.querySelector("style[data-sass-component='InputOTP_InputOTP']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var OTPField = function OTPField(_ref) {
  var index = _ref.index,
    value = _ref.value,
    focusOnClick = _ref.focusOnClick,
    error = _ref.error,
    setError = _ref.setError,
    required = _ref.required,
    disabled = _ref.disabled,
    setInternalValue = _ref.setInternalValue;
  var fakeField = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hasFocus = _useState2[0],
    setHasFocus = _useState2[1];
  (0, _react.useEffect)(function () {
    if (required) {
      if (index === value.position) {
        var _fakeField$current, _fakeField$current$pa;
        if (!((_fakeField$current = fakeField.current) != null && (_fakeField$current$pa = _fakeField$current.parentNode) != null && _fakeField$current$pa.contains(document.activeElement))) {
          if (value.string.length < 6) {
            if (!error) {
              setError && setError(true);
            }
          } else {
            if (error) {
              setError && setError(false);
            }
          }
        }
      }
    }
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: fakeField,
    className: "OTPInput__singleField ".concat(error ? 'OTPInput__singleField--error' : '', " ").concat(disabled ? 'OTPInput__singleField--disabled' : ''),
    tabIndex: disabled ? undefined : value.position === index || index === 0 ? 0 : -1,
    onClick: focusOnClick,
    "aria-label": "one time input field ".concat(index),
    "aria-details": value.string,
    onFocus: function onFocus() {
      if (index === 0) {
        if (value.position === null) {
          setInternalValue({
            string: '',
            position: 0
          });
        }
      }
      if (!hasFocus) {
        setHasFocus(true);
      }
    },
    onBlur: function onBlur() {
      if (hasFocus) {
        setHasFocus(false);
      }
    },
    children: value.string[index]
  });
};
var OTPInput = function OTPInput(_ref2) {
  var tooltip = _ref2.tooltip,
    tooltipAlign = _ref2.tooltipAlign,
    mobileTooltipAlign = _ref2.mobileTooltipAlign,
    setValue = _ref2.setValue,
    label = _ref2.label,
    labelClass = _ref2.labelClass,
    helperText = _ref2.helperText,
    required = _ref2.required,
    noErrorsOrHelper = _ref2.noErrorsOrHelper,
    errorText = _ref2.errorText,
    description = _ref2.description,
    error = _ref2.error,
    setError = _ref2.setError,
    disabled = _ref2.disabled,
    rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _useState3 = (0, _react.useState)({
      string: '',
      position: null
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    value = _useState4[0],
    setInternalValue = _useState4[1];
  var container = (0, _react.useRef)(null);
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    firstTimeFocused = _useState6[0],
    setFirstTimeFocused = _useState6[1];
  var restring = (0, _react.useCallback)(function (string, position, newCh) {
    var backspace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (position === 0 && !backspace) return newCh + string.substring(position + 1);
    if (backspace) return (position > 0 ? string.substring(0, position) : '') + string.substring(position + 1);
    return string.substring(0, position) + newCh + string.substring(position + 1);
  }, []);
  (0, _react.useEffect)(function () {
    var _container$current;
    if ((_container$current = container.current) != null && _container$current.contains(document.activeElement)) {
      if (value.position !== null) {
        var _container$current2;
        var target = container == null ? void 0 : (_container$current2 = container.current) == null ? void 0 : _container$current2.children[value.position];
        if (target) {
          // @ts-ignore
          target.focus();
        }
      }
    }
  });
  var setPositionOnClick = function setPositionOnClick(index, _ref3) {
    var string = _ref3.string,
      position = _ref3.position;
    if (position || position === 0) {
      if (string.length - 1 === -1) return 0;
      if (index > string.length - 1) return string.length - 1;
      return index;
    }
    return 0;
  };
  var focusOnClick = function focusOnClick(index) {
    return function (e) {
      e.preventDefault();
      setInternalValue(function (current) {
        var output = {};
        output.string = current.string;
        output.position = setPositionOnClick(index, current);
        return output;
      });
      if (!firstTimeFocused) {
        setFirstTimeFocused(true);
      }
    };
  };
  var onPasteHandler = function onPasteHandler(e) {
    e.preventDefault();
    var paste = e.clipboardData.getData('text');
    if (paste.match(/^[0-9]{1,6}$/)) {
      setInternalValue({
        string: paste,
        position: paste.length - 1
      });
      setValue && setValue(paste);
    }
  };
  var labelKeyDownHandler = function labelKeyDownHandler(e) {
    if (e.key.match(/^[0-9]$/)) {
      setInternalValue(function (current) {
        var output = {};
        output.position = current.position === 5 ? 5 : (current == null ? void 0 : current.position) !== null && current.position + 1;
        output.string = restring(current.string, current.position || 0, e.key);
        return output;
      });
      if (error) {
        if (value.string.length === 5) {
          setError && setError(false);
        }
      }
    } else if (e.key === 'Backspace') {
      setInternalValue(function (current) {
        var output = {};
        output.position = current.position === 0 ? 0 : (current == null ? void 0 : current.position) !== null && current.position - 1;
        output.string = restring(current.string, current.position || 0, '', true);
        return output;
      });
    } else if (e.key === 'ArrowRight') {
      if (value.position !== 5) {
        if (value.string.length - 1 >= (value.position || 0)) {
          setInternalValue(function (current) {
            var output = {};
            output.position = current.position === null ? 0 : current.position + 1;
            output.string = current.string;
            return output;
          });
        }
      }
    } else if (e.key === 'ArrowLeft') {
      setInternalValue(function (current) {
        var output = {};
        output.position = current.position === 0 ? 0 : (current == null ? void 0 : current.position) !== null && current.position - 1;
        output.string = current.string;
        return output;
      });
    }
  };
  var labelKeyUpHandler = function labelKeyUpHandler(e) {
    if (e.key.match(/^[0-9]$/) || e.key === 'Backspace') {
      setValue && setValue(value.string);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", _objectSpread(_objectSpread({
    tabIndex: -1,
    className: "OTPInput ".concat(disabled ? 'OTPInput--disabled' : '')
  }, rest), {}, {
    onKeyDown: labelKeyDownHandler,
    onKeyUp: labelKeyUpHandler,
    onPaste: onPasteHandler,
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Label["default"], {
      helperText: helperText,
      className: labelClass,
      tooltip: tooltip,
      error: error || false,
      tooltipAlign: tooltipAlign,
      mobileTooltipAlign: mobileTooltipAlign,
      required: required,
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      "aria-label": "one time password input",
      ref: container,
      className: "OTPInput__fieldContainer",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(OTPField, {
        index: 0,
        value: value,
        focusOnClick: focusOnClick(0),
        error: error || false,
        setError: setError,
        required: required,
        disabled: disabled,
        setInternalValue: setInternalValue
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(OTPField, {
        index: 1,
        value: value,
        focusOnClick: focusOnClick(1),
        error: error || false,
        setError: setError,
        required: required,
        disabled: disabled,
        setInternalValue: setInternalValue
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(OTPField, {
        index: 2,
        value: value,
        focusOnClick: focusOnClick(2),
        error: error || false,
        setError: setError,
        required: required,
        disabled: disabled,
        setInternalValue: setInternalValue
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(OTPField, {
        index: 3,
        value: value,
        focusOnClick: focusOnClick(3),
        error: error || false,
        setError: setError,
        required: required,
        disabled: disabled,
        setInternalValue: setInternalValue
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(OTPField, {
        index: 4,
        value: value,
        focusOnClick: focusOnClick(4),
        error: error || false,
        setError: setError,
        required: required,
        disabled: disabled,
        setInternalValue: setInternalValue
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(OTPField, {
        index: 5,
        value: value,
        focusOnClick: focusOnClick(5),
        error: error || false,
        setError: setError,
        required: required,
        disabled: disabled,
        setInternalValue: setInternalValue
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Below["default"], {
      noErrorsOrHelper: noErrorsOrHelper,
      error: error || false,
      errorText: errorText,
      description: description
    })]
  }));
};
var _default = OTPInput;
exports["default"] = _default;